window.roleFormatter = function(value, row) {
    let html = '';
    if (can('admin.settings.authorization.roles.permissions')) {
        html += '<a href="'+route('admin.settings.authorization.roles.show', row.role_id)+'">'+value+'</a>';
    } else {
        html += value;
    }
    return html;
}
